import { inject, Pipe, PipeTransform } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

@Pipe({
  name: 'minutesToHoursMinutes',
  standalone: true,
})
export class MinutesToHoursMinutesPipe implements PipeTransform {
  readonly translate = inject(TranslateService);

  transform(timeInMinutes: number): string {
    if (!timeInMinutes || typeof timeInMinutes !== 'number') {
      timeInMinutes = 0;
    }

    const minusValue = timeInMinutes < 0 ? '-' : '';
    const positiveTimeInMinutes = Math.abs(timeInMinutes);
    const hours = Math.trunc(positiveTimeInMinutes / 60);
    const minutes = Math.round(positiveTimeInMinutes % 60);

    let result = '';

    if (hours !== 0) {
      result =
        result + `${hours}${this.translate.instant('general.time.hours')} `;
    }
    if (minutes !== 0) {
      result =
        result + `${minutes}${this.translate.instant('general.time.minutes')} `;
    }
    if (minutes === 0 && hours === 0) {
      result = `0${this.translate.instant('general.time.hours')} `;
    }

    return (`${minusValue} ` + result).trim();
  }
}
